/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response after disconnecting Gmail
 * @export
 * @interface GmailDisconnectResponse
 */
export interface GmailDisconnectResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GmailDisconnectResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GmailDisconnectResponse
     */
    message: string;
}

/**
 * Check if a given object implements the GmailDisconnectResponse interface.
 */
export function instanceOfGmailDisconnectResponse(value: object): value is GmailDisconnectResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function GmailDisconnectResponseFromJSON(json: any): GmailDisconnectResponse {
    return GmailDisconnectResponseFromJSONTyped(json, false);
}

export function GmailDisconnectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailDisconnectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function GmailDisconnectResponseToJSON(json: any): GmailDisconnectResponse {
    return GmailDisconnectResponseToJSONTyped(json, false);
}

export function GmailDisconnectResponseToJSONTyped(value?: GmailDisconnectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

